import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { templeTrust_detail } from '../api/DonationBillApi/DonationCillapi';

const DonarPublicHeaderComponent = (props) => {
  const { templeUuid: routeTempleUuid } = useParams();
  const templeUuid = props.templeUuid || routeTempleUuid;
  const templeId = props.templeId;
  const [templeDetail, setTempleDetail] = useState({});
  useEffect(() => {
    const fetchTemple = async () => {
      if (!templeUuid && !templeId) return;
      try {
        const { data } = await templeTrust_detail(templeUuid, templeId);
        if (data.status === 200) {
          setTempleDetail({
            ...data.payload.data
          });
        }
      } catch (error) {
        console.log('error >> ', error);
      }
    };
    fetchTemple();
  }, [templeUuid, templeId]);
  const templeName = templeDetail?.templeName || 'શ્રી સ્વામિનારાયણ મંદિર';

  const templeAddress = templeDetail?.address
    ? `${templeDetail.address}, ${templeDetail.city}, ${templeDetail.state}, ${templeDetail.country}`
    : '';
  const { secondTitle, therdTitle } = props;
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        marginBottom: '20px',
        alignItems: 'center',
        'text-align': 'center'
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <p
          style={{
            fontSize: '12px',
            letterSpacing: '2px',
            color: '#e64141',
            fontWeight: '700'
          }}
        >
          ||श्री स्वामिनारायणो विजयतेतराम्||
        </p>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <p
          style={{
            fontSize: '20px',
            letterSpacing: '2px',
            color: `${secondTitle}`
          }}
        >
          {'શ્રી સરધારધામ સંચાલિત'}
        </p>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <p
          style={{
            fontSize: '30px',
            letterSpacing: '2px',
            color: `${therdTitle}`
          }}
        >
          {templeName ? templeName : 'શ્રી સ્વામિનારાયણ મંદિર'}
        </p>
      </div>
      {templeAddress && (
        <p
          style={{
            fontSize: '15px',
            marginTop: '5px',
            color: '#555',
            maxWidth: '700px'
          }}
        >
          {templeAddress}
        </p>
      )}
    </div>
  );
};

export default DonarPublicHeaderComponent;
